export const cleanFilters = (filters: object) =>
  Object.fromEntries(
    Object.entries(filters).filter(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ([_, value]) => value !== null && value !== ""
    )
  );
